import { Box, Text } from '@chakra-ui/react';
import { ReactElement } from 'react';

type Props = {
  amountTokens: number | '∞';
  colors: {
    background: string;
    text: string;
  };
};

export const AiSubscriptionTokenBadge = ({ amountTokens, colors }: Props): ReactElement => {
  return (
    <Box background={colors.background} borderRadius="7px" padding="2px 7px">
      <Text textStyle="body.s.medium" color={colors.text}>
        {amountTokens} KI-Erstellungen frei
      </Text>
    </Box>
  );
};
